import React from "react";
import { LoadingSpinner as DefaultLoadingSpinner } from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import styles from "./spinner.module.scss";

function LoadingSpinner() {
  return (
    <div className={styles.spinnerContainer}>
      <DefaultLoadingSpinner />
    </div>
  );
}

export default LoadingSpinner;
